<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('category')">
              category
              <i
                :class="
                  currentSort === 'category'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('jenpek')">
              Jenis Pekerjaan
              <i
                :class="
                  currentSort === 'jenpek'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>

            <th @click="sort('risiko_area_tambang')">
              Tingkat Risiko Area Operasi Tambang Inti/Non
              <i
                :class="
                  currentSort === 'risiko_area_tambang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>

            <th @click="sort('risiko_tambang')">
              Tingkat Risiko Tambang Inti/Non
              <i
                :class="
                  currentSort === 'risiko_tambang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>

            <th @click="sort('risiko_area_non_tambang')">
              Tingkat Risiko Area Operasi Non Tambang
              <i
                :class="
                  currentSort === 'risiko_area_non_tambang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>

            <th @click="sort('risiko_non_tambang')">
              Tingkat Risiko Non Tambang Inti/Non
              <i
                :class="
                  currentSort === 'risiko_non_tambang'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>

            <th @click="sort('iujp_code')">
              Kode IUJP
              <i
                :class="
                  currentSort === 'iujp_code'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kbli_code')">
              Kode KBLI
              <i
                :class="
                  currentSort === 'kbli_code'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.category }}</td>
            <td>{{ list.jenpek }}</td>
            <td>{{ list.tresiko_operasi_tambang }}</td>
            <td>{{ list.tresiko_tambang }}</td>
            <td>{{ list.tresiko_oprasi_non_tambang }}</td>
            <td>{{ list.tresiko_non_tambang }}</td>
            <td>{{ list.iujp_code }}</td>
            <td>{{ list.kbli_code }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBUB
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBUB: () => import('@/views/MasterData/Edit/K3L/KBUB.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        category: '',
        jenpek: '',
        tresiko_operasi_tambang: '',
        tresiko_tambang: '',
        tresiko_oprasi_non_tambang: '',
        tresiko_non_tambang: '',
        iujp_code: '',
        kbli_code: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          id: '1',
          category: 'Layanan Internet',
          jenpek:
            'Jasa Penyediaan/ pengadaan jalur sewa untuk komunikasi data dan layanan jaringan internet.',
          tresiko_area_operasi_tambang: '-',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'C2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '61921',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: '2',
          category: 'Sistem Telepon',
          jenpek:
            'Jasa Pemasangan Sistem Telepon Kabel termasuk PABX dan id extensi',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '43212',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: '3',
          category: 'Sistem Telepon',
          jenpek:
            'Jasa Pemeliharaan Sistem Telepon Kabel termasuk PABX dan id extensi',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '61100',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: '4',
          category: 'Layanan Radio',
          jenpek: 'Jasa Pemasangan sistem jaringan komunikasi radio.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '43212',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          id: '5',
          category: 'Layanan Radio',
          jenpek: 'Jasa Pemeliharaan sistem jaringan komunikasi radio.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '43212',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          id: '6',
          category: 'Layanan Jaringan Siaran Televisi',
          jenpek: 'Jasa Pemasangan jaringan TV kabel.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '43212',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          id: '7',
          category: 'Layanan Jaringan Siaran Televisi',
          jenpek: 'Jasa Pemeliharaan jaringan TV kabel.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '95120',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          id: '8',
          category: 'Layanan Dispatch di Tambang',
          jenpek: 'Jasa Pemasangan sistem dispatch truk untuk armada truk.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'C1',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '61200',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          id: '9',
          category: 'Layanan Dispatch di Tambang',
          jenpek: 'Jasa Pemeliharaan sistem dispatch truk untuk armada truk.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'C1',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '61200',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          id: '10',
          category: 'Perkabelan Jaringan Data',
          jenpek: 'Jasa Pemasangan sistem perkabelan jaringan data.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '43212',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          id: '11',
          category: 'Perkabelan Jaringan Data',
          jenpek: 'Jasa Pemeliharaan sistem perkabelan jaringan data.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B2',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '61100',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          id: '12',
          category: 'Pembangunan Fasilitas Komunikasi',
          jenpek: 'Jasa Pembangunan menara komunikasi',
          tresiko_area_operasi_tambang: 'A',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B1',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '42206',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          id: '13',
          category: 'Pembangunan Fasilitas Komunikasi',
          jenpek: 'Jasa Pembangunan fasilitas-fasilitas pendukungnya.',
          tresiko_area_operasi_tambang: 'A',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'B1',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '61922',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          id: '14',
          category: 'Layanan Perangkat Keras',
          jenpek:
            'Jasa Pemasangan komputer desktop, notebook, printer dan peripheral komputer lainnya.',
          tresiko_area_operasi_tambang: 'B1',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'C1',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '63990',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          id: '15',
          category: 'Layanan Perangkat Keras',
          jenpek:
            'Jasa pemeliharaan komputer desktop, notebook, printer dan - peripheral komputer lainnya.',
          tresiko_area_operasi_tambang: '-',
          tresiko_tambang: 'N',
          tresiko_area_operasi_non_tambang: 'C1',
          tresiko_non_tambang: 'N',
          iujp_code: '-',
          kbli_code: '63990',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        category: data.category,
        jenpek: data.jenpek,
        tresiko_operasi_tambang: data.tresiko_operasi_tambang,
        tresiko_tambang: data.tresiko_tambang,
        tresiko_oprasi_non_tambang: data.tresiko_oprasi_non_tambang,
        tresiko_non_tambang: data.tresiko_non_tambang,
        iujp_code: data.iujp_code,
        kbli_code: data.kbli_code,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    kbubData() {
      const result = this.$store.state.mdDatabaseStore.kbubData
      return result
    },
    sortedData() {
      return this.kbubData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
